module.exports = __webpack_public_path__ + "static/media/ye.d13e1629.svg";